import { Helmet } from "react-helmet-async";
import { Landing } from "@/components/Landing";
import { config } from "@/lib/config";

export function CatalogPage() {
  return (
    <>
      <Helmet>
        <title>{config.appName} · Menu</title>
        <meta
          name="description"
          content="JMANATX — Text NEW to 512.633.3579 for your customer #. Austin cannabis delivery menu: flower, pre-rolls, edibles, specials. 21+."
        />
        <link rel="canonical" href={`${config.publicSiteUrl}/`} />
      </Helmet>
      <Landing />
    </>
  );
}
